export default __webpack_public_path__ + "static/media/screen5.b9345cbb.png";